import useMediaQuery from '@eversports/klimt-design-components/use-media-query'
import useTheme from '@eversports/klimt-design-components/use-theme'
import Box from '@eversports/klimt-primitives/legacy/Box'

import { useIntl } from '../../../localization/react'
import { STACKED_POSITIONS } from '../Search.constants'
import type { CitySearchResult, InventorySearchResult, SearchComponentProps } from '../Search.types'
import SearchComponent from '../SearchComponent'
import SearchSvg from '../SearchInput/SearchSvg'

interface Props extends SearchComponentProps<InventorySearchResult> {
  location: CitySearchResult
  isDefaultOpen?: boolean
}

const SearchInventoryComponent = ({
  searchValue,
  setSearchValue,
  results,
  handleResultClick,
  handleResultEnter,
  isLoading,
  hasInputLabels,
  searchPosition,
  isDefaultOpen = false,
}: Props) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const intl = useIntl()

  const inputLabel = intl.searchForSportOrVenueLabel()

  const searchPlaceholder =
    isMobile && !hasInputLabels ? intl.searchInventoryPlaceholderMobile() : intl.searchInventoryPlaceholderDesktop()

  return (
    <Box flex={{ xs: STACKED_POSITIONS.includes(searchPosition) ? 1 : 3, sm: 3 }} position="relative">
      <SearchComponent
        inputLabel={inputLabel}
        hasInputLabels={hasInputLabels}
        searchPosition={searchPosition}
        iconAdornment={<SearchSvg size={12} />}
        placeholder={searchPlaceholder}
        searchValue={searchValue}
        setSearchValue={setSearchValue}
        results={results}
        handleResultClick={handleResultClick}
        handleResultEnter={handleResultEnter}
        isLoading={isLoading}
        isDefaultOpen={isDefaultOpen}
      />
    </Box>
  )
}

export default SearchInventoryComponent
